import { Injectable, ApplicationRef } from "@angular/core";
import { JsonApiService } from "@app/core/services/json-api.service";
import { Subject, Observable } from "rxjs";
import { Select } from "@app/core/models/select";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "@env/environment";
import { JwtHelper } from "angular2-jwt";
import { AlertifyService } from "@app/core/services/alertify.service";

@Injectable()
export class FirmService {
  public state;
  public data: {};
  public currentLanguage: any;

  constructor(
    private httpClient: HttpClient,
    private alertifyService: AlertifyService
  ) { }

  API_URL = environment.API_URL;
  userToken: any;
  userName: any;
  decodedToken: any;
  jwtHelper: JwtHelper = new JwtHelper();
  TOKEN_KEY = "token";

  getFirmsForSelect(): Observable<Select[]> {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    return this.httpClient.get<Select[]>(
      this.API_URL + "firmusers/getFirmsByUser",
      { headers: headers }
    );
  }

  selectFirm(firmID) {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    headers = headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );
    this.httpClient
      .post(this.API_URL + "firmusers/selectfirm", firmID, { headers: headers })
      .subscribe(data => {
        this.setTokenOperations(data);
        this.alertifyService.success("Firmanız değiştirildi.");
        window.location.reload(true);
      });
  }

  setTokenOperations(data: any) {
    this.saveToken(data["sPassword"]);
    this.userToken = data["sPassword"];
    this.userName = data["sEmail"];
    this.saveUserName(data["sEmail"]);
    sessionStorage.setItem("firmTitle", data["sFirmTitle"]);
    this.decodedToken = this.jwtHelper.decodeToken(
      data["sPassword"].toString()
    );
  }

  saveToken(token) {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  saveUserName(userName) {
    sessionStorage.setItem("userName", userName);
  }
}
